import cookies from './util.cookies.js'

let util = {
  cookies,
}

/**
 * @description 更新标题
 * @param {String} title 标题
 */
util.title = function (titleText) {
  const processTitle = '嘉盈智慧物流(天津)有限公司'
  window.document.title = `${processTitle}${titleText ? ` | ${titleText}` : ''}`
}

util.formatDate = function (date,fmt) { 
  var o = {   
    "M+" : date.getMonth()+1,                 //月份   
    "d+" : date.getDate(),                    //日   
    "h+" : date.getHours(),                   //小时   
    "m+" : date.getMinutes(),                 //分   
    "s+" : date.getSeconds(),                 //秒   
    "q+" : Math.floor((date.getMonth()+3)/3), //季度   
    "S"  : date.getMilliseconds()             //毫秒   
  };   
  if(/(y+)/.test(fmt))
    fmt=fmt.replace(RegExp.$1, (date.getFullYear()+"").substr(4 - RegExp.$1.length));   
  for(var k in o)
    if(new RegExp("("+ k +")").test(fmt))   
    fmt = fmt.replace(RegExp.$1, (RegExp.$1.length==1) ? (o[k]) : (("00"+ o[k]).substr((""+ o[k]).length)));   
  return fmt;   
}

util.compareDate = function (checkStartDate, checkEndDate) {
  var arys1 = new Array();
  var arys2 = new Array();
  if (checkStartDate && checkEndDate) {
    arys1 = checkStartDate.split('-');
    var sdate = new Date(arys1[0], parseInt(arys1[1] - 1), arys1[2]);
    arys2 = checkEndDate.split('-');
    var edate = new Date(arys2[0], parseInt(arys2[1] - 1), arys2[2]);
    return (sdate > edate)
  }
  return false;
}

util.arrayUnique=function(arr, name) {
  var hash = {};
  return arr.reduce(function(item, next) {
      hash[next[name]] ? "" : (hash[next[name]] = true && item.push(next));
      return item;
  }, []);
}

util.getThousandNumber=function(num) {
  return (num || 0).toString().replace(/\d+/, function (n) {
      var len = n.length;
      if (len % 3 === 0) {
          return n.replace(/(\d{3})/g, ',$1').slice(1);
      } else {
          return n.slice(0, len % 3) + n.slice(len % 3).replace(/(\d{3})/g, ',$1');
      }
  });
}
export default util

/**
 * 清空对象所有属性
 * @param temp
 */
export function resetTemp(temp) {
  for(let prop in temp){
    temp[prop] = null;
  }
  return temp;
}


// WEBPACK FOOTER //
// ./src/libs/util.js